exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".purchase-info-panel{background:#fff;box-shadow:0 1px 3px rgba(0,0,0,.12),0 1px 3px rgba(0,0,0,.24);margin-bottom:20px;padding:18px;display:flex;flex-flow:row wrap}.purchase-info-panel header{font-family:Helvetica Neue,Helvetica,Arial,sans-serif;font-size:1.8rem;margin-bottom:10px}.purchase-info-panel .order-info,.purchase-info-panel .order-info-dates{width:100%}.purchase-info-panel .order-info-dates .labeled-string,.purchase-info-panel .order-info .labeled-string{-ms-flex-pack:justify;justify-content:space-between}.purchase-info-panel .order-info-dates .labeled-string .data-key,.purchase-info-panel .order-info .labeled-string .data-key{text-align:right}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./~/sass-loader!./src/product/details/components/purchase-info-panel.scss
// module id = 5120
// module chunks = 0